import React from "react";
import { Box, Button, Column, Columns } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";
import usePostDiaryEntry from "../../hooks/usePostDiaryEntry";

function NewDiaryEntry() {
  const [taskFor, taskForInput, setTaskFor] = useInput({
    type: "text",
    label: "Task For"
  });
  const [comments, commentsInput, setComments] = useInput({
    type: "text",
    label: "Comments",
    size: "two-fifths"
  });

  const [startDate, stateDateInput, setStartDate] = useInput({
    type: "date",
    label: "Start Date",
    initialValue: null
  });

  const [time, timeInput, setTime] = useInput({
    type: "time",
    label: "Time",
    initialValue: null
  });

  const [endDate, endDateInput, setEndDate] = useInput({
    type: "date",
    label: "End Date (Leave blank for 1 day entry)",
    initialValue: null
  });

  const [, postDiaryEntry] = usePostDiaryEntry({
    task_for: taskFor,
    time: time || null,
    start_date: startDate || null,
    end_date: endDate || null,
    comments
  });

  const handleSubmit = () => {
    postDiaryEntry();
    setTaskFor("");
    setComments("");
    setStartDate("");
    setTime("");
    setEndDate("");
  };

  return (
    <Box>
      <Columns isMultiline>
        {taskForInput}
        {commentsInput}
        {stateDateInput}
        {timeInput}
        {endDateInput}
      </Columns>

      <Columns isMultiline>
        <Column>
          <Button onClick={handleSubmit} color={"success"} isFullWidth>
            Add
          </Button>
        </Column>
      </Columns>
    </Box>
  );
}

export default NewDiaryEntry;
